export const isDecodedFormat = format => !!Object.getOwnPropertyDescriptor(format, "fontFamily");
export const isEncodedFormat = format => !!Object.getOwnPropertyDescriptor(format, "format1");
//# sourceMappingURL=Format.js.map